import type { ISearchQuery } from '../models/query';

export const CORE_TARGET_MAX = 1000;
export const DEFAULT_TARGET_MAX = 5000;
export const CORE_TARGET_WARNING_THRESHOLD = 500;
export const CORE_TARGET_WARNING = `To ensure best match for experts, smaller more targeted searches of ${CORE_TARGET_WARNING_THRESHOLD} or less are recommended.`;

export const TARGET_MAX_BY_CORE_NETWORK: Readonly<
  Record<NonNullable<ISearchQuery['coreNetwork']>, number>
> = {
  core: CORE_TARGET_MAX,
  noncore: DEFAULT_TARGET_MAX,
  all: DEFAULT_TARGET_MAX,
};

export const getTargetMaxForCoreNetwork = (
  coreNetwork: ISearchQuery['coreNetwork']
): number => TARGET_MAX_BY_CORE_NETWORK[coreNetwork ?? 'all'];
